//Ref. https://reacttraining.com/react-router/web/example/auth-workflow

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Proptypes from 'prop-types';

function PrivateRoute(props) {
  const {
    component: Component,
    isAuthenticated = false,
    publicRedirect = '/',
    ...rest
  } = props

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            push={false}
            to={{
              pathname: publicRedirect,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

PrivateRoute.propTypes = {
  component: Proptypes.func.isRequired,
  isAuthenticated: Proptypes.bool,
};

export default PrivateRoute;
